module.exports = __webpack_public_path__ + "static/media/registration-mails.cbb98c68.png";